module.exports = __webpack_public_path__ + "assets/img/capstone_preview_2.86e1696.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/capstone_preview_2.png
// module id = 45
// module chunks = 0